(ns practitest.frontend.signup.views
  (:require
   [practitest.frontend.signup.components.fields :as fields]
   [practitest.frontend.signup.events :as events]
   [practitest.frontend.signup.subs :as subs]
   [practitest.frontend.login.views :as login-views]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.routing.backend-routes :as broutes]
   [re-frame.core :as re-frame]))

(defn signup-page [_route]
  [:div.login-page
   [login-views/left-panel]
   [:div.right
    [:div.right-inner
     [:div.form-title (get-translation "signup.edit.title" "Welcome to PractiTest")]
     [:form.form
      {:on-submit (fn [e]
                    (.preventDefault e)
                    (re-frame/dispatch [::events/submit-signup]))}
      [fields/email-field]
      [fields/name-field]
      [fields/password-block]
      [fields/time-zone-field]
      [fields/locale-field]
      [fields/terms-field]
      [fields/submit-button]
      [fields/error-box]]]]])

(defn new-signup-page [_route]
  [:div.login-page
   [login-views/left-panel]
   [:div.right
    [:div.right-inner
     [:div.form-title (get-translation "signup.title" "Welcome to PractiTest Trial")]
     [:p.forgot-password-description
      (get-translation "signup.subtitle" "Before you choose your project, please fill in the details below:")]
     [fields/already-registered-banner]
     [:form.form
      {:method    "post"
       :action    (broutes/get-url "signups#create")
       :on-submit (fn [e]
                    (if (events/valid-password? @(re-frame/subscribe [::subs/signup :password ""])
                                                @(re-frame/subscribe [::subs/password-complexity-pattern]))
                      (re-frame/dispatch [::events/update-field :client-error nil])
                      (do
                        (.preventDefault e)
                        (re-frame/dispatch [::events/update-field :client-error (fields/password-hint-text)]))))}
      [fields/hidden-signup-fields]
      [fields/email-field]
      [fields/name-field {:native-form? true}]
      [fields/password-block {:native-form? true}]
      [fields/time-zone-field {:native-form? true}]
      [fields/locale-field {:native-form? true}]
      [fields/terms-field {:native-form? true}]
      [fields/submit-button]
      [fields/error-box]]
     [fields/signup-iframe]]]])
